import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RewardService } from 'src/app/core/api/reward/reward.service';
import { SnackBarService } from 'src/app/core/services/snackbar/snackbar.service';
import { MatDialogResponse } from 'src/app/shared/models/constants/mat-dialog-response';
import { RewardResponseDTO } from 'src/app/shared/models/dtos/responses/reward-response-dto/reward-response-dto';

@Component({
  selector: 'app-delete-reward-modal',
  templateUrl: './delete-reward-modal.component.html',
  styleUrls: ['./delete-reward-modal.component.scss'],
})
/**
 * Modal for deleting a reward.
 */
export class DeleteRewardModalComponent {
  loading = false;
  /**
   * Constructor
   */
  constructor(
    private dialogRef: MatDialogRef<DeleteRewardModalComponent>,
    private rewardService: RewardService,
    private readonly snackBarService: SnackBarService,
    @Inject(MAT_DIALOG_DATA) public data: RewardResponseDTO
  ) {
    this.dialogRef.disableClose = this.loading ?? false;
  }

  /**
   * Action to close the dialog
   */
  onDialogClose() {
    this.dialogRef.close(MatDialogResponse.FAIL);
  }

  /**
   * Deletes reward by id
   */
  deleteReward() {
    this.loading = true;
    this.rewardService.deleteReward(this.data.id).subscribe({
      next: () => {
        this.dialogRef.close(MatDialogResponse.SUCCESS);
        this.snackBarService.success('Reward deleted successfully');
      },
      error: () => {
        this.dialogRef.close(MatDialogResponse.FAIL);
        this.snackBarService.error('Error deleting reward');
      },
      complete: () => {
        this.loading = false;
      },
    });
  }
}
